import { ArrowRight, Download } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { heroBadges } from "../../data/content";
import TechBadge from "../ui/TechBadge";

export default function Hero() {
  const { t } = useApp();

  return (
    <section id="home" className="relative overflow-hidden pb-16 pt-32 sm:pt-40">
      {/* Background layers */}
      <div className="pointer-events-none absolute inset-0 grid-bg opacity-60" />
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[36rem] w-[36rem] -translate-x-1/2 rounded-full bg-cyan-500/20 blur-[120px]" />
      <div className="pointer-events-none absolute right-0 top-40 h-80 w-80 rounded-full bg-purple-500/20 blur-[110px]" />

      <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="animate-fade-in inline-flex items-center gap-2 rounded-full border border-soft card-bg px-4 py-1.5 text-xs font-medium text-soft">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
            </span>
            {t("hero.eyebrow")}
          </span>

          <h1 className="animate-fade-up mt-6 font-display text-4xl font-extrabold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
            <span className="gradient-text">Senior Frontend</span> &<br className="hidden sm:block" />{" "}
            Full-Stack Developer
          </h1>

          <p className="animate-fade-up mx-auto mt-6 max-w-2xl text-base leading-relaxed text-soft sm:text-lg" style={{ animationDelay: "80ms" }}>
            {t("hero.subtitle")}
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-soft/80 sm:text-base">
            {t("hero.secondary")}
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#projects"
              className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-cyan-400 to-blue-500 px-6 py-3 text-sm font-semibold text-slate-950 shadow-lg shadow-cyan-500/25 transition-transform hover:scale-[1.03] sm:w-auto"
            >
              {t("hero.cta.projects")}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
            <button
              type="button"
              onClick={() => window.open(`${import.meta.env.VITE_LINKEDIN_URL}`, "_blank")}
              aria-label={t("hero.cta.cv")}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-soft card-bg px-6 py-3 text-sm font-semibold transition-colors hover:border-cyan-400/50 hover:text-cyan-400 sm:w-auto"
            >
              <Download className="h-4 w-4" />
              {t("hero.cta.cv")}
            </button>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
            {heroBadges.map((b) => (
              <TechBadge key={b} label={b} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
